import axios from "axios";

// Menggunakan environment variable dari .env file
// Untuk Create React App, gunakan process.env.REACT_APP_*
const baseURL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3002';

const Api = axios.create({
    baseURL: baseURL,
    withCredentials: true, // Wajib agar HTTP-only cookie dikirim otomatis oleh browser
    headers: {
        'Content-Type': 'application/json'
    }
})

// Debug: Log base URL yang digunakan (bisa dihapus di production)
console.log('API Base URL:', baseURL);

Api.interceptors.request.use((config) => {
    // Dengan HTTP-only cookie, token dikelola otomatis oleh browser
    // Tidak perlu mengambil token dari localStorage

    // Jika data adalah FormData, hapus Content-Type header
    // agar browser secara otomatis mengatur multipart/form-data dengan boundary
    if (config.data instanceof FormData) {
        delete config.headers['Content-Type'];
    }

    return config;
});

export default Api;